import React from "react";

const Team = () => <div>For more details: Mail us at:jiit.ucr@gmail.com</div>;

export default Team;
